// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"propertiesPage_placeholder__RNXUz","container":"propertiesPage_container__3u8u4","header":"propertiesPage_header__2gqx9"};
    if(module.hot) {
      // 1790670302431
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  